import { render, staticRenderFns } from "./CharacterAddingDialog.vue?vue&type=template&id=319a8b3c&lang=pug&"
import script from "./CharacterAddingDialog.vue?vue&type=script&lang=js&"
export * from "./CharacterAddingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterAddingDialog.vue"
export default component.exports